import { trpc } from "../../../modules/main/components/trpc.ts";
import type {
  CCAMDeleteFavoriteInput,
  CCAMUpsertFavoriteInput,
} from "cadendar-shared";

export const useCCAMFavorites = () => {
  const utils = trpc.useUtils();

  const favoritesQuery = trpc.ccam.listFavorites.useQuery(undefined, {
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
  });

  const upsertMutation = trpc.ccam.upsertFavorite.useMutation({
    onSuccess: async () => {
      await utils.ccam.listFavorites.invalidate();
    },
  });

  const deleteMutation = trpc.ccam.deleteFavorite.useMutation({
    onSuccess: async () => {
      await utils.ccam.listFavorites.invalidate();
    },
  });

  const upsertFavorite = async (input: CCAMUpsertFavoriteInput) => {
    return upsertMutation.mutateAsync(input);
  };

  const deleteFavorite = async (input: CCAMDeleteFavoriteInput) => {
    return deleteMutation.mutateAsync(input);
  };

  return {
    favorites: favoritesQuery.data ?? [],
    isLoading: favoritesQuery.isLoading,
    error: favoritesQuery.error,
    upsertFavorite,
    deleteFavorite,
    isSaving: upsertMutation.isPending,
    isDeleting: deleteMutation.isPending,
    mutationError: upsertMutation.error ?? deleteMutation.error,
  };
};
